import { Outlet, useLocation } from '@tanstack/react-router';
import OrgInfo from '@/features/public/booking/components/OrgInfo.tsx';
import { bookingRoute } from '@/features/public/booking/routes/bookingRoutes.ts';
import BookingNotOpenContent from '@/features/public/booking/components/BookingNotOpenContent.tsx';
import BookingRegistrationClosedContent from '@/features/public/booking/components/BookingRegistrationClosedContent.tsx';
import BookingTourCancelledContent from '@/features/public/booking/components/BookingTourCancelledContent.tsx';
import BookingSoldOutContent from '@/features/public/booking/components/BookingSoldOutContent.tsx';
import TourInfoBox from '@/features/public/booking/components/TourInfoBox.tsx';
import { PageTitle } from '@/components/ui/Title.tsx';

const BookingLayout = () => {
  const location = useLocation();
  const { tourBasicInfo, bookingView } = bookingRoute.useLoaderData();

  const isChildRoute =
    location.pathname.includes('confirmation') ||
    location.pathname.includes('summary');

  const showBookingFlow = bookingView.type === 'booking' || isChildRoute;

  return (
    <div className="lg:grid lg:grid-cols-[1fr_minmax(0,600px)_1fr] lg:gap-8 lg:px-4">
      <div className="hidden justify-end lg:flex lg:pt-20">
        <OrgInfo tourBasicInfo={tourBasicInfo} />
      </div>

      <div className="mt-10 space-y-2 px-4 lg:mt-20 lg:px-0">
        <div className="mb-6 space-y-4">
          <div className="space-y-1">
            {showBookingFlow && !location.pathname.includes('confirmation') && (
              <>
                <PageTitle>Rejestracja na {tourBasicInfo.tourName}</PageTitle>
                <div className="text-neutral-600">
                  {location.pathname.includes('summary')
                    ? 'Krok 2 z 2: Podsumowanie rezerwacji'
                    : 'Krok 1 z 2: Informacje o uczestnikach'}
                </div>
              </>
            )}
            {!showBookingFlow && bookingView.type === 'not-open' && (
              <BookingNotOpenContent tourBasicInfo={tourBasicInfo} />
            )}
            {!showBookingFlow && bookingView.type === 'registration-closed' && (
              <BookingRegistrationClosedContent tourBasicInfo={tourBasicInfo} />
            )}
            {!showBookingFlow && bookingView.type === 'tour-cancelled' && (
              <BookingTourCancelledContent tourBasicInfo={tourBasicInfo} />
            )}
            {!showBookingFlow && bookingView.type === 'sold-out' && (
              <BookingSoldOutContent tourBasicInfo={tourBasicInfo} />
            )}
          </div>

          {/* Pod nagłówkiem kroku, nie nad nim: pierwsze, co klient ma
              zobaczyć, to na czym stoi w rejestracji. */}
          <TourInfoBox tourBasicInfo={tourBasicInfo} className="lg:hidden" />
        </div>
        {showBookingFlow && <Outlet />}
      </div>
    </div>
  );
};

export default BookingLayout;
